<template>
  <div @keyup.enter="onFilter">
    <!-- Header session -->
    <b-row class="mb-3">
      <b-col cols="2">
        <b-input-group>
          <date-picker placeholder="Từ ngày" class="form-control form-control-sm" :config="dpConfigs.date"
            v-model="localParams.startDate" @keyup.enter="onFilter"></date-picker>
        </b-input-group>
      </b-col>
      <b-col cols="2">
        <b-input-group>
          <date-picker placeholder="Đến ngày" class="form-control form-control-sm" :config="dpConfigs.date"
            v-model="localParams.endDate" @keyup.enter="onFilter"></date-picker>
        </b-input-group>
      </b-col>
      <b-col cols="2">
        <b-input ref="imeiInput" size="sm" placeholder="IMEI" v-model="localParams.imeiCode"></b-input>
      </b-col>
      <b-col cols="2">
        <b-input size="sm" placeholder="Số điện thoại" v-model="localParams.customerPhone"></b-input>
      </b-col>
      <b-col cols="2">
        <b-input size="sm" placeholder="Tên khách hàng" v-model="localParams.customerName"></b-input>
      </b-col>
      <b-col cols="2">
        <BDropdownCustom :value="statusSelectedObjects" :options="statusOptions" :placeholder="'trạng thái'"
          :searchable="true" :match-key="['name', 'id']" text-prop="name" value-prop="id"
          @valueChange="onStatusChange" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        <b-form-select class="select-style" size="sm" v-model="localParams.companyId" :options="listCompany"
          value-field="id" text-field="name" />
      </b-col>
      <b-col cols="2">
        <b-input size="sm" placeholder="ID phiếu" v-model.trim="localParams.id" />
      </b-col>
      <b-col cols="2">
        <b-input size="sm" placeholder="Mã phiếu" v-model.trim="localParams.code" />
      </b-col>
      <b-col cols="3">
        <BDropdownCustom v-model="localParams.storeIds" :options="optionStores" :placeholder="'cửa hàng'"
          :searchable="true" :match-key="['name', 'shortName']" :limit="10" />
      </b-col>
      <b-col cols="3">
        <BDropdownCustom v-model="localParams.previousStoreIds" :options="allOptionStores"
          :placeholder="'cửa hàng chuyển đến'" :searchable="true" :match-key="['name', 'shortName']" :limit="10" />
      </b-col>
    </b-row>
    <b-collapse id="warranty-advanced-search" class="mt-3 mb-2">
      <b-row class="mb-3">
        <b-col cols="2">
          <BDropdownCustom v-model="localParams.transferStatus" :options="transferStatusOptions"
            :placeholder="'trạng thái chuyển'" :searchable="false" :match-key="['name']" text-prop="name"
            value-prop="id" :limit="10" />
        </b-col>
        <b-col cols="2">
          <EmployeeSearch :value="localParams.primaryTechnicianName" placeholder="Kĩ thuật viên sửa chữa"
            @employee-selected="onRepairTechnicianSelected" />
        </b-col>
        <b-col cols="3">
          <b-form-select size="sm" v-model="localParams.warrantyServiceId" :options="warrantyServiceOptions"
            value-field="id" text-field="name" class="select-style">
            <template v-slot:first>
              <b-form-select-option :value="null">--Loại dịch vụ--</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="3">
          <b-input size="sm" placeholder="Tên sản phẩm" v-model="localParams.productName" />
        </b-col>
        <b-col cols="2">
          <EmployeeSearch :value="localParams.inspectedByEmployeeName" placeholder="Kĩ thuật viên kiểm tra"
            @employee-selected="onInspectionTechnicianSelected" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <BDropdownCustom v-model="localParams.criteriaIds" :options="criteriaOptions" :placeholder="'đặc điểm'"
            :searchable="true" :match-key="['name']" text-prop="name" value-prop="id" :limit="10" />
        </b-col>
        <b-col cols="3">
          <Autosuggest
            :model="selectedCreditAcc"
            :suggestions="filteredCreditAccOptions"
            placeholder="tài khoản quẹt thẻ"
            :limit="10"
            @select="onCreditAccSelected"
            @change="onInputCreditAccChange"
          />
        </b-col>
        <b-col cols="3">
          <b-input size="sm" placeholder="Mã giao dịch" v-model.trim="localParams.paymentCode" />
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mb-5 mt-3">
      <b-col class="d-flex align-items-center" style="gap: 12px">
        <b-button-group size="sm">
          <b-button class="font-weight-bold" variant="primary" style="width: 70px" @click="onFilter"
            :disabled="isLoading">Lọc</b-button>
          <b-button variant="primary" v-b-toggle.warranty-advanced-search class="togge-filter"
            aria-label="Mở rộng bộ lọc nâng cao">
            <i class="fas fa-angle-down toggle-filter-icon"></i>
          </b-button>
        </b-button-group>
        <b-button style="font-weight: 600; width: auto; min-width: 120px" variant="secondary" size="sm" @click="onReset"
          :disabled="isLoading || activeFilterCount === 0" class="ml-2">
          Xóa bộ lọc
          <span v-if="activeFilterCount > 0">({{ activeFilterCount }})</span>
        </b-button>
      </b-col>
    </b-row>
    <!-- End of Header session -->
  </div>
</template>

<script>
import timeUtils from '@/utils/date'
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue'
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
import ApiService from '@/core/services/api.service'
import { removeAccents } from '@/utils/common'
import { ACCOUNTANT_TYPE } from '@/utils/enum'

export default {
  name: 'WarrantySearchBar',
  components: { BDropdownCustom, EmployeeSearch, Autosuggest },
  props: {
    params: {
      type: Object,
      default: () => ({
        code: null,
        imeiCode: null,
        customerPhone: null,
        customerName: null,
        startDate: null,
        endDate: null,
        status: [],
        storeIds: [],
        previousStoreIds: [],
        criteriaIds: [],
        transferStatus: [],
      }),
    },
    optionStores: {
      type: Array,
      default: () => [],
    },
    allOptionStores: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: Number,
      default: null,
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    optionPageSize: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    warrantyServiceOptions: {
      type: Array,
      default: () => [],
    },
    listCompany: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dpConfigs: timeUtils.DP_CONFIG,
      localParams: { productName: null, primaryTechnicianName: null, primaryTechnicianId: null, inspectedByEmployeeName: null, inspectedByEmployeeId: null, warrantyServiceId: null, companyId: null, creditUnitIds: [], paymentCode: null, ...this.params },
      localPageSize: this.pageSize,
      selectedCreditAcc: '',
      filteredCreditAccOptions: [],
      creditAccOptions: [{ data: [] }],
      criteriaOptions: [
        { id: 'HAS_DEBT', name: 'Còn công nợ' },
        { id: 'NO_DEBT', name: 'Hết công nợ' },
        { id: 'CANNOT_REPAIR', name: 'Không sửa được' },
        { id: 'DISAGREE_PRICE', name: 'Không đồng ý giá' },
      ],
      transferStatusOptions: [
        { id: 'PENDING', name: 'Chờ xác nhận' },
        { id: 'CONFIRMED', name: 'Đã nhận' },
      ],
    }
  },
  computed: {
    statusSelectedObjects() {
      const ids = this.localParams.status || []
      return this.statusOptions.filter((s) => ids.includes(s.id))
    },
    activeFilterCount() {
      const params = this.localParams
      let count = 0
      if (params.code && String(params.code).trim()) count++
      if (params.imeiCode && String(params.imeiCode).trim()) count++
      if (params.customerPhone && String(params.customerPhone).trim()) count++
      if (params.customerName && String(params.customerName).trim()) count++
      if (params.startDate) count++
      if (params.endDate) count++
      const statusIds = params.status || []
      if (statusIds.length > 0) count++
      const storeIds = params.storeIds || []
      if (storeIds.length > 0) count++
      const previousStoreIds = params.previousStoreIds || []
      if (previousStoreIds.length > 0) count++
      const criteriaIds = params.criteriaIds || []
      if (criteriaIds.length > 0) count++
      const transferStatus = params.transferStatus || []
      if (transferStatus.length > 0) count++
      if (params.productName && String(params.productName).trim()) count++
      if (params.primaryTechnicianId) count++
      if (params.inspectedByEmployeeId) count++
      if (params.warrantyServiceId) count++
      if (params.companyId) count++
      const creditUnitIds = params.creditUnitIds || []
      if (creditUnitIds.length > 0) count++
      if (params.paymentCode && String(params.paymentCode).trim()) count++
      return count
    },
  },
  async created() {
    await this.fetchCreditAccounts()
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.imeiInput.$el.focus()
    })
  },
  watch: {
    params: {
      handler(newVal) {
        this.localParams = { ...newVal }
      },
      deep: true,
    },
    pageSize(newVal) {
      this.localPageSize = newVal
    },
    localPageSize(newVal) {
      this.$emit('page-size-change', newVal)
    },
  },
  methods: {
    onRepairTechnicianSelected(employee) {
      this.localParams.primaryTechnicianName = employee ? employee.name : null
      this.localParams.primaryTechnicianId = employee ? employee.id : null
    },
    onInspectionTechnicianSelected(employee) {
      this.localParams.inspectedByEmployeeName = employee ? employee.name : null
      this.localParams.inspectedByEmployeeId = employee ? employee.id : null
    },
    onStatusChange(selectedObjects) {
      this.localParams = {
        ...this.localParams,
        status: (selectedObjects || []).map((o) => o.id),
      }
    },
    async fetchCreditAccounts() {
      const res = await ApiService.query('accountants/getByType', { params: { type: ACCOUNTANT_TYPE.CREDIT, pageSize: 1000 } })
      const raw = res.data?.data
      const items = Array.isArray(raw) ? raw : []
      const mapped = items
        .filter((item) => item.level >= 2)
        .map((item) => ({ id: item.id, name: item.name }))
      this.creditAccOptions = [{ data: mapped }]
      this.filteredCreditAccOptions = [...mapped]
    },
    onCreditAccSelected(option) {
      this.selectedCreditAcc = option.item.name
      this.localParams.creditUnitIds = option.item.id ? [option.item] : []
    },
    onInputCreditAccChange(text) {
      this.selectedCreditAcc = text
      this.localParams.creditUnitIds = []
      const filteredData = this.creditAccOptions[0].data
        .filter((item) =>
          removeAccents(item.name).toLowerCase().indexOf(removeAccents(text || '').toLowerCase()) > -1
        )
        .slice(0, 10)
      this.filteredCreditAccOptions = [...filteredData]
    },
    onFilter() {
      this.$emit('filter', this.localParams)
    },
    onReset() {
      const resetParams = {
        code: null,
        imeiCode: null,
        customerPhone: null,
        customerName: null,
        startDate: null,
        endDate: null,
        status: [],
        storeIds: [],
        previousStoreIds: [],
        criteriaIds: [],
        transferStatus: [],
        productName: null,
        primaryTechnicianName: null,
        primaryTechnicianId: null,
        inspectedByEmployeeName: null,
        inspectedByEmployeeId: null,
        warrantyServiceId: null,
        companyId: null,
        creditUnitIds: [],
        paymentCode: null,
      }
      this.localParams = resetParams
      this.localParams.storeIds = []
      this.localParams.previousStoreIds = []
      this.selectedCreditAcc = ''
      this.filteredCreditAccOptions = [...(this.creditAccOptions[0]?.data || [])]
      this.localPageSize = null
      this.$emit('reset', resetParams)
    },
  },
}
</script>

<style scoped>
.togge-filter {
  background-color: #3d8cdd;
  border-color: #3d8cdd;
}

.toggle-filter-icon {
  display: inline-block;
  transition: transform 0.2s ease;
}

.togge-filter[aria-expanded='true'] .toggle-filter-icon {
  transform: rotate(180deg);
}
</style>
